import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SimpleMatDataSource } from '../../common/providers/simple-mat-data-source';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UsersProvider } from '../../users/providers/users-provider';
import {
  MobileModuleContentComponent,
  ModuleMenu
} from "../../common/components/mobile-module-content/mobile-module-content";
import { DocumentService } from '../../document/providers/document.service';
import { UploadDialogComponent } from '../../document/components/dialog/dialog.component';
import { DownloaderHelper } from '../../document/helpers/downloader.helper';
import { BytesPipe } from 'ngx-pipes';
import { PreviewDialogComponent } from '../../document/components/preview-dialog/preview-dialog.component';
import { DocumentRights } from '../../document/providers/document-rights';
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { CurrentUserRolesProvider } from '../../organizations/providers/current-user-roles-provider';
import { CurrentUser } from "../../common/providers/current-user";
import { ConfigProvider } from "../../config-provider.service";
import { Title } from '@angular/platform-browser';
import { forkJoin, map, Observable, Subscription, switchMap } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Organization } from "../../common/models/organization";
import { Athlete } from "../../common/models/athlete";
import { User } from "../../common/models/user";
import { Document } from "../../common/models/document";
import { Paginator } from "../../common/models/paginator";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { ConfirmDialogComponent } from "../../common/components/confirm-dialog/confirm-dialog";
import { MobilePageContentComponent } from "../../common/components/mobile-page-content/mobile-page-content";
import { MobileHeaderComponent } from "../../common/components/mobile-header/mobile.header";
import { MobileSideMenuComponent } from "../../common/components/mobile-side-menu/mobile.side-menu.component";
import { Error401Component } from "../../common/components/error-401/error-401";
import { Error404Component } from "../../common/components/error-404/error-404";
import { MatTable, MatTableModule } from "@angular/material/table";
import { NgIf } from "@angular/common";
import { AppDatePipe } from "../../common/pipes/app-date";
import { MatIconButton } from "@angular/material/button";
import { MatMenu, MatMenuModule, MatMenuTrigger } from "@angular/material/menu";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { AthletesProvider } from "../../athletes/providers/athletes-provider";
import { CoachesProvider } from "../../coaches/providers/coaches-provider";
import { AthleteCoach } from "../../common/models/athlete-coach";
import { Coach } from "../../common/models/coach";
import { MatSortModule } from "@angular/material/sort";

@Component({
  selector: 'app-mobile-document-list',
  templateUrl: './mobile.document.list.component.html',
  styleUrls: ['./mobile.document.list.component.scss'],
  standalone: true,
  imports: [
    MatPaginator,
    MobilePageContentComponent,
    MobileHeaderComponent,
    MobileSideMenuComponent,
    Error401Component,
    Error404Component,
    MobileModuleContentComponent,
    MatTableModule,
    NgIf,
    MatSortModule,
    TranslateModule,
    AppDatePipe,
    MatIconButton,
    MatMenuTrigger,
    MatIconModule,
    MatMenuModule
  ],
  providers: [BytesPipe]
})
export class MobileDocumentListComponent implements OnInit, AfterViewInit, OnDestroy {

    public isLoading = true;
    public is401 = false;
    public is404 = false;

    public dataSource: SimpleMatDataSource = new SimpleMatDataSource([]);
    public columns: string[] = ['name', 'createDate', 'action'];

    public organization: Organization = {} as Organization;
    public athleteUser: User = {} as User;

    public paginatedResults: Paginator = {} as Paginator;
    public pageSize: number = Document.NUM_ITEMS;
    public currentPage = 0;
    public totalSize = 0;
    public pageTitle: string | null = null;

    public mainActions: ModuleMenu[] = [];

    public docRights: DocumentRights = new DocumentRights(this.utils);

    @ViewChild(MatPaginator, {static: false}) public paginator: MatPaginator | undefined;

    private subscriptions: Subscription[] = [];

    constructor(
        public conf: ConfigProvider,
        private title: Title,
        private documentProvider: DocumentService,
        private route: ActivatedRoute,
        private translator: TranslateService,
        private userProvider: UsersProvider,
        private dialog: MatDialog,
        private previewDialog: MatDialog,
        private toaster: MatSnackBar,
        private utils: UtilsProvider,
        private currentUserRoles: CurrentUserRolesProvider,
        private currentUser: CurrentUser,
        private api: ApiBaseService,
        private athletesProvider: AthletesProvider,
        private coachesProvider: CoachesProvider
    ) {
    }

    public ngOnInit(): void {
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => { //{ organization: Organization; athlete: Athlete; user: User }
                this.organization = data.organization;
                this.athleteUser = data.athlete;

                this.loadPaginatedData().subscribe(() => {

                    this.docRights.evaluateScreenRights({
                        rolesIds: this.currentUserRoles.getRolesIds(this.organization.id!)
                    });

                    if (!this.docRights.LIST) {
                        this.is401 = true;
                        return;
                    }

                    if (this.docRights.ADD) {
                        this.mainActions = [{
                            title: 'Add',
                            icon: 'add',
                            url: '',
                            onClick: () => this.openUploadDialog()
                        }];
                    }

                    this.createPageTitle();
                    this.isLoading = false;
                });
            })
        );
    }

    public ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator!;
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public loadPaginatedData(page = 0, query = ''): Observable<any> {
      return this.documentProvider.getByAthletePaginated(this.organization, this.athleteUser.athlete!, page, query).pipe(
        map((paginator: Paginator) => {
          this.paginatedResults = paginator;
          this.currentPage = this.paginatedResults.current_page - 1;
          this.pageSize = this.paginatedResults.per_page;
          this.totalSize = this.paginatedResults.total;

          this.dataSource.replaceAllWith(this.paginatedResults.data);

            this.paginatedResults = paginator;
            this.currentPage = this.paginatedResults.current_page - 1;
            this.pageSize = this.paginatedResults.per_page;
            this.totalSize = this.paginatedResults.total;

            this.paginatedResults.data.forEach((row: any) => {
              this.docRights.setItemRightsList(row);
              row.rights = this.docRights.getItemRightsList();
            });

            this.dataSource.replaceAllWith(this.paginatedResults.data);
        })
      );
    }

    /**
     * Perform a new request for the requested page
     *
     * @param event
     */
    public onPaginateChange(event: any) {
        this.loadPaginatedData(event.pageIndex + 1).subscribe();
    }

    public onFilterKeyup(filter: string): void {
        this.loadPaginatedData(0, filter).subscribe();
    }

    public onDeleteClicked(row: any) {
        const dialog: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(ConfirmDialogComponent, {
            data: {
                confirmText: 'DocumentConfirmDelete',
                confirmActionText: 'Delete',
                confirmColor: 'primary'
            }
        });
        this.subscriptions.push(
            dialog.afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    this.documentProvider.deleteById(this.organization, this.athleteUser.athlete!, row.id).subscribe(
                        (data) => {
                            this.toaster.open(this.translator.instant('Document_Deleted'), '', {duration: 5000});
                        },
                        (err) => {
                            this.toaster.open(err.error.message, '', {duration: 5000});
                        },
                        () => {
                            this.loadPaginatedData(this.currentPage + 1).subscribe();
                        });
                }
            })
        );
    }

    public openUploadDialog() {
        const dialogRef: MatDialogRef<UploadDialogComponent> = this.dialog.open(UploadDialogComponent, {
            height: '80%',
            data: {
                organization: this.organization,
                athlete: this.athleteUser.athlete,
            }
        });
        this.subscriptions.push(
            dialogRef.componentInstance.filesUploaded.subscribe(() => {
                this.loadPaginatedData(this.currentPage + 1).subscribe();
            })
        );
    }

    public onPreviewClicked(d: Document) {

        const dialogRef: MatDialogRef<PreviewDialogComponent> = this.previewDialog.open(PreviewDialogComponent, {
            // height: '80%',
            data: {
                organization: this.organization,
                athlete: this.athleteUser.athlete,
                document: d,
            }
        });
    }

    public download(d: Document) {
        this.subscriptions.push(
            this.documentProvider.download(this.organization, this.athleteUser.athlete!, d).subscribe((response: Response) => {
                DownloaderHelper.forceDownload(response as any as Blob, d.originalName??'document');
            })
        );
    }

    private createPageTitle() {
        this.pageTitle = this.translator.instant('Documents');
        this.title.setTitle(this.pageTitle + ' | ' + this.conf.platformName);
    }
}
